module.exports = __webpack_public_path__ + "static/img/fws_banner.e984a24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jieju/fws_banner.png
// module id = SJL5
// module chunks = 1